import React, { ReactElement, ReactNode } from 'react';
import {
  Controller,
  ControllerFieldState,
  ControllerRenderProps,
  FieldValues,
  Path,
  useFormContext,
} from 'react-hook-form';

interface FormCellProps<T extends FieldValues> {
  id: Path<T>;
  defaultValue?: any;
  children: (field: ControllerRenderProps<T, Path<T>>, fieldState: ControllerFieldState) => ReactElement | ReactNode;
}

export const FormCell = <T extends FieldValues>({ children, id, defaultValue }: FormCellProps<T>) => {
  const { control } = useFormContext<T>();

  return (
    <span data-cy={`form-field-${id}`} key={id}>
      <Controller
        key={id}
        name={id}
        control={control}
        defaultValue={defaultValue}
        render={({ field, fieldState }) => {
          return children(field, fieldState) as ReactElement;
        }}
      />
    </span>
  );
};
